<template>
    <div class="article securities">
        <div class="article-meta">
            <div class="article-meta-container">
                <div v-if="security" class="security">

                    <p class="subheader"><a href="/market/securities">Listed Securities</a></p>
                    <h1>{{ security.IssuerDisplay }}</h1>

                    <div class="field-list" v-if="security.TradingData && security.TradingData.LatestQuotePrice">
                        <div class="field-list-field">
                            <label>Today's Price Data</label>
                            <p>Price data up to 15 min delayed</p>
                        </div>
                        <div class="field-list-field col">
                            <label>Bid:</label>
                            <output>{{ security.CurrencyIsoCode }} {{ security.TradingData.LatestQuotePrice.BidPrice}}</output>
                            <!--<output v-else-if="stats.CloseBid">{{ stats.CurrencyIsoCode }} {{ stats.CloseBid}}</output>-->
                        </div>
                        <div class="field-list-field col">
                            <label>Ask:</label>
                            <output>{{ security.CurrencyIsoCode }} {{ security.TradingData.LatestQuotePrice.AskPrice}}</output>
                            <!--<output v-else-if="stats.CloseAsk">{{ stats.CurrencyCode }} {{ stats.CloseAsk}}</output>-->
                        </div>
                        <div class="field-list-field col">
                            <label>Mid:</label>
                            <output>{{ security.CurrencyIsoCode }} {{ Mid }}</output>
                            <!--<output v-else-if="stats.CloseMid">{{ stats.CurrencyCode }} {{ stats.CloseMid}}</output>-->
                        </div>
                    </div>

                    <hr v-if="security.TradingData && security.TradingData.LatestQuotePrice" />

                    <div class="field-list col">
                        <div class="field-list-field">
                            <label>Mnemonic:</label>
                            <output>{{ security.Mnemonic }}</output>
                        </div>
                        <div class="field-list-field">
                            <label>Security Type:</label>
                            <output>{{ security.Type === "Bond" ? "Bond" : security.SubtypeDisplay }}</output>
                        </div>
                        <div class="field-list-field">
                            <label>Currency:</label>
                            <output>{{ security.CurrencyIsoCode }}</output>
                        </div>
                        <div class="field-list-field">
                            <label>Security Class:</label>
                            <output>{{ security.Name }}</output>
                        </div>
                        <div class="field-list-field" v-if="security.TradingInformation && security.TradingInformation.MarketMakers && security.TradingInformation.MarketMakers.length">
                            <label>Market Maker:</label>
                            <output v-for="marketMaker in security.TradingInformation.MarketMakers">
                                <a :href="`/members/current-members/${marketMaker.Mnemonic}`">{{ marketMaker.Name }}</a>
                            </output>
                        </div>
                    </div>

                    <hr />

                    <div class="field-list col">
                        <template v-for="isin in security.AllIsins" v-if="security.AllIsins.length > 0">
                            <div class="field-list-field" v-if="isin.Type == 'IsinCode' && isin.Code">
                                <label>ISIN<span v-if="isin.Comment"> ({{isin.Comment}})</span>:</label>
                                <output>{{ isin.Code }}</output>
                            </div>
                            <div class="field-list-field" v-if="isin.Type == 'CommonCode' && isin.Code">
                                <label>Common Code<span v-if="isin.Comment">  ({{isin.Comment}})</span>:</label>
                                <output>{{ isin.Code }}</output>
                            </div>
                        </template>
                        <!--<div class="field-list-field" v-if="security.AllIsins.length > 0">
            <label>ISIN:</label>
            <div>
                <output v-for="isin in security.AllIsins">{{isin.Type}}: {{ isin.Code }}  {{isin.Comment}}</output>
            </div>
        </div>
        <div class="field-list-field" v-if="security.CommonCode">
            <label>Common Code:</label>
            <output>{{ security.CommonCode }}</output>
        </div>-->
                        <div class="field-list-field">
                            <label>Date Listed:</label>
               
                            <output>{{ format(parseISO(security.ListedAt), "dd-MM-yyyy") }}</output>
                        </div>
                        
                        <div class="field-list-field">
                            <label>Domicile:</label>
                            <output>{{ security.IssuerDetail.Address.Country.Name }}</output>
                        </div>
                        <div class="field-list-field">
                            <label>{{ AgentOrSponsorLabel}}:</label>
                            <output><a v-if="AgentOrSponsor" :href="AgentOrSponsorUrl">{{ AgentOrSponsor }}</a></output>
                        </div>
                        <!-- Removed with Janus
        <div class="field-list-field">
            <label>Category:</label>
            <output>{{ security.CompanyCategory }}</output>
        </div>-->

                        <div class="field-list-field">
                            <label>Issuer:</label>
                            <output><a v-if="security.Issuer" :href="IssuerUrl">{{ security.IssuerDetail.Name }}</a></output>
                        </div>
                        <!--<div v-if="security.IsTiseSustainable" class="field-list-field">
            <label>Segment:</label>
            <output>TISE SUSTAINABLE</output>
        </div>-->
                    </div>

                    <hr />

                    <div class="field-list" v-if="security.IssuerDetail.Address">
                        <div class="field-list-field">
                            <label>Company Address:</label>
                            <br />
                            <output>
                                <template v-if="security.IssuerDetail.Address.Line1">
                                    {{ security.IssuerDetail.Address.Line1 }}
                                    <br />
                                </template>
                                <template v-if="security.IssuerDetail.Address.Line2">
                                    {{ security.IssuerDetail.Address.Line2 }}
                                    <br />
                                </template>
                                <template v-if="security.IssuerDetail.Address.Line3">
                                    {{ security.IssuerDetail.Address.Line3 }}
                                    <br />
                                </template>
                                <template v-if="security.IssuerDetail.Address.City">
                                    {{ security.IssuerDetail.Address.City }}
                                    <br />
                                </template>
                                <template v-if="security.IssuerDetail.Address.Postcode">
                                    {{ security.IssuerDetail.Address.Postcode }}
                                    <br />
                                </template>
                                <template v-if="security.IssuerDetail.Address.Country">
                                    {{ security.IssuerDetail.Address.Country.Name }}
                                </template>
                            </output>
                        </div>
                    </div>

                    <hr v-if="security.IssuerDetail.Address" />

                </div>
                <div v-else class="skeleton">
                    <p class="subheader">Listed Securities</p>
                    <h2></h2>
                    <h1></h1>
                    <p></p>
                    <hr />
                    <p class="long"></p>
                    <hr />
                    <p></p>
                    <p class="long"></p>
                    <hr />
                </div>
            </div>
        </div>
        <div class="article-content">
            <SecurityDetails :security="security" :stats="stats" />
        </div>
    </div>
</template>

<script>

    import { format, parseISO } from 'date-fns';
    import SecurityDetails from './security-details.vue';

    export default {
        props: {
            theme: String,
            mnemonic: {
                type: String,
                required: true
            }
        },
        components: {
            SecurityDetails
        },
        data() {
            return {
                baseUrl: '/market/securities',
                sponsorUrl: '/members/current-members',
                companiesUrl: '/market/companies',
                securityUrl: `/api/Securities/${this.mnemonic}`,
                statsUrl: `/api/price-statistic/${this.mnemonic}`,
                security: null,
                stats: null,
                format: format,
                parseISO: parseISO
            };
        },
        computed: {
            Mid() {
                if (this.security.TradingData && this.security.TradingData.LatestQuotePrice) {
                    var n = (this.security.TradingData.LatestQuotePrice.BidPrice + this.security.TradingData.LatestQuotePrice.AskPrice) / 2
                    // Convert to number and round to 4 decimal places
                    const rounded = Number(n).toFixed(4);

                    // Parse back to float to check trailing zeros
                    const floatNum = parseFloat(rounded);

                    // If the number has no decimal part or only zeros after 2 decimals
                    //if (floatNum === Math.floor(floatNum) || Number(floatNum.toFixed(4)).toString().slice(-2) === '00') {
                    //    return floatNum.toFixed(2);
                    //}

                    // Otherwise return up to 4 decimal places, removing trailing zeros
                    return parseFloat(floatNum.toFixed(4)).toString();
                }
                else {
                    return 0
                }
            },
            AgentOrSponsorLabel() {
                if (this.security?.Type === 'Bond') {
                    return "Listing Agent";
                }
                return "Sponsor";
            },
            AgentOrSponsor() {
                return this.security.Member.Name;
            },
            AgentOrSponsorUrl() {
                return `${this.sponsorUrl}/${this.security.Member.Mnemonic}`;
            },
            eventsUrl() {
                return `/api/companyNews/${this.mnemonic}`;
            },
            hasStats() {
                return this.stats && (this.stats.CloseBid || this.stats.BestBid);
            },
            IssuerUrl() {
                return `${this.companiesUrl}/${this.security.Issuer.Mnemonic}`;
            }
        },
        methods: {
            HandleNewlines(value) {
                return value ? value.replace(/(?:\r\n|\r|\n)/g, '<br />') : '';
            },
            LoadData() {
                fetch(this.securityUrl, {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' }
                }).then((response) => {
                    response.json().then((data) => {
                        this.security = data;
                        if (this.security.ListedDate) this.security.ListedDate = parseISO(this.security.ListedDate);
                        if (this.security.DelistedDate) this.security.DelistedDate = parseISO(this.security.DelistedDate);
                    });
                });
            },
            LoadStatsData() {
                //fetch(this.statsUrl, {
                //    method: 'GET',
                //    headers: { 'Content-Type': 'application/json' }
                //})
                //    .then(response => response.json())
                //    .then((data) => {
                //        this.stats = data;
                //    });
            },
        },
        beforeMount() {
            this.LoadData();
            this.LoadStatsData();
        }
    };
</script>